import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { RouterStateSnapshot, TitleStrategy } from "@angular/router";
 
 
 
@Injectable({providedIn: 'root'})
export class TemplateTitleStrategy extends TitleStrategy{
    private readonly suffix = ' | One Tax Bahamas';
 
    constructor(private readonly title: Title){
        super();
    }
 
    override updateTitle(snapshot: RouterStateSnapshot): void {
        const routeTitle = this.buildTitle(snapshot);
 
        if(routeTitle){
            this.title.setTitle(`${routeTitle}${this.suffix}`)
        }else{
            this.title.setTitle('One Tax Bahamas');
        }
    }
}